import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Warehouse as WarehousePage } from '@/pages/warehouse';
import { commonSearchSchema } from '@/routes/-shared/commonSearchSchema';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { useTenantFeatureFlags } from '@/lib/hooks/use-tenant-feature-flags';
import z from '@/lib/zod';
import {
  optionalSearchBoolean,
  optionalSearchString,
} from '@/lib/zod-search-params';

export const warehouseSearchSchema = commonSearchSchema.extend({
  subTab: z.string().nullish(),
  warehouseId: optionalSearchString(),
  lowStockOnly: optionalSearchBoolean(),
  isActiveProduct: optionalSearchBoolean(),
  adjustmentsOnly: optionalSearchBoolean(),
  // Pannello Filtri (tavola 8a): periodo di inventari e movimenti, stati
  // degli inventari e tipi di movimento come CSV, con i nomi dell'API.
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
  statuses: optionalSearchString(),
  movementTypes: optionalSearchString(),
  // Estensioni per i sub-tab embedded (Inventari, Listini, Prodotti) cosi`
  // la stessa URL puo` veicolare i loro filtri senza route change.
  status: optionalSearchString(),
  companyId: optionalSearchString(),
  categoryId: optionalSearchString(),
  activeOnly: optionalSearchBoolean(),
});

export type WarehouseSearchSchema = z.infer<typeof warehouseSearchSchema>;

export const Route = createFileRoute('/protected/_layout/warehouse/_layout')({
  validateSearch: warehouseSearchSchema,
  component: WarehouseLayout,
});

function WarehouseLayout() {
  const { canAccessWarehouse, isLoading } = usePermissions();
  const { isWarehouseEnabled, isLoading: isFeatureFlagsLoading } =
    useTenantFeatureFlags();
  return (
    <RoleGuard
      hasAccess={canAccessWarehouse && isWarehouseEnabled}
      isLoading={isLoading || isFeatureFlagsLoading}
    >
      <WarehousePage />
      <Outlet />
    </RoleGuard>
  );
}
